import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import butterflyApi from '../ButterflyApi.js';
import MobilePage from '../UiComponents/MobilePage';
import { isLogin, logout } from '../Utils/Cookies.js';
import BookSlideList from './BookSlideList.js';
import BookRowList from './BookRowList.js';
import { callName } from '../Utils/Strings';
import Utils from "../utils";
import { getAppProductionStatusText, hasPaidAppProduction, replaceAppTitleCallName } from '../AppPayment/appProductionStatus.js';
import './Home.css';

// Set to true to show game creation buttons and prices again.
const SHOW_GAME_CREATION = false

const ProcessingRolling = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (!items || items.length === 0) return
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % items.length)
    }, 10000)
    return () => clearInterval(interval)
  }, [items])

  if (!items || items.length === 0) return null

  const item = items[currentIndex % items.length]

  return (
    <div className="home-activity">
      <img src={item.imageUrl + "?300"} alt="" width="36" height="36" />
      <div>
        <span className="home-activity-label">새로운 이야기가 도착했어요</span>
        <p><strong>{item.maskedHeroName}</strong>님의 동화가 완성되었어요.</p>
      </div>
      <span className="home-activity-dot" aria-hidden="true" />
    </div>
  )
}

const SectionHeading = ({ id, title, description, icon, children }) => (
  <div className="home-section-heading">
    <div>
      <h2 id={id}><img src={icon} alt="" width="32" height="32" />{title}</h2>
      <p>{description}</p>
    </div>
    {children}
  </div>
)

const MOVIE_ITEMS = [
  {
    title: '하늘이는 헤어디자이너',
    youtubeUrl: 'https://www.youtube.com/shorts/bEavnpuJOu4',
    embedUrl: 'https://www.youtube.com/embed/bEavnpuJOu4?playsinline=1&controls=1&modestbranding=1&rel=0&iv_load_policy=3',
    thumbnailUrl: 'https://img.youtube.com/vi/bEavnpuJOu4/hqdefault.jpg',
  },
  {
    title: '슈퍼 킥보드',
    youtubeUrl: 'https://www.youtube.com/shorts/d4G5OCMjFFw',
    embedUrl: 'https://www.youtube.com/embed/d4G5OCMjFFw?playsinline=1&controls=1&modestbranding=1&rel=0&iv_load_policy=3',
    thumbnailUrl: 'https://img.youtube.com/vi/d4G5OCMjFFw/hqdefault.jpg',
  },
]

const getMovieEmbedUrl = (movie) => {
  const separator = movie.embedUrl.includes('?') ? '&' : '?'
  return `${movie.embedUrl}${separator}autoplay=1`
}

const getAppName = (app, heroName) => {
  return replaceAppTitleCallName(app.appName, app, heroName)
}

const formatPrice = (price) => {
  if (price === undefined || price === null) return ''
  return `${new Intl.NumberFormat('ko-KR').format(price)}원`
}

const getPurchasePrice = (app) => {
  if (app.salePrice === undefined || app.salePrice === null) return
  return Math.max(app.salePrice - (app.discountPrice || 0), 0)
}

const Suggetion = ({ hero, features, makingStories, complatedStories, heroName }) => {

  if (!isLogin()) {
    return <div>
    </div>
  }

  if (!hero) {
    return <div className='mt-4 mb-16 text-base/7'>
      <a href="/heroes/add" className=' '>
        주인공을 추가해 주세요.<br />우리 아이가 동화의 주인공이 됩니다.
      </a>
    </div>
  }

  if (features.filter(feature => feature.heroFeatureNo == 5).length == 0
    && features.filter(feature => feature.heroFeatureNo == 9).length == 0) {
    return <div className='mt-4 mb-16 text-base/7'>
      <a href={`heroes/${hero.heroNo}/setting`} className=' '>
        {heroName}의 가족을 등록해 주세요.<br />가족이 동화에 등장하게 됩니다.
      </a>
    </div>
  }

  if (!hero.imageUrl) {
    return <div className=''>
      <a href={`heroes/${hero.heroNo}/setting`} className=' underline underline-offset-4 '>
        {heroName}의 사진을 등록하면 아이의 모습으로 동화 삽화가 만들어집니다.
      </a>
    </div>
  }


  if ((!complatedStories || complatedStories.length == 0)
    && (!makingStories || makingStories.length == 0)
  ) {
    return <div className=''>
      {heroName}의 이야기를 만들고 있습니다.
    </div>
  }

  return <div>

  </div>

}

const Main = ({ }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scripts, setScripts] = useState([])
  const [heroNo, setHeroNo] = useState()
  const [hero, setHero] = useState()
  const [features, setFeatures] = useState([])
  const [processing, setProcessing] = useState([])
  const [apps, setApps] = useState([])
  const [activeMovie, setActiveMovie] = useState()

  const load = async () => {
    await loadScript()
    await loadProcessing()
    await loadApps()
  }

  const loadScript = async () => {
    const heroNo = isLogin() ? localStorage.getItem("heroNo") : 1
    const response = await butterflyApi.getScripts(isLogin() && heroNo)
    if (!response || response.items.length == 0) {
      logout()
      window.location.reload()
    }
    setScripts(response.items)
    if (!isLogin() || !heroNo) return
    const hero = JSON.parse(localStorage.getItem("heroes"))?.filter(hero => hero.heroNo == heroNo)[0]
    if (!hero) {
      //잘못된 heroNo를 가지고 있는 것으로 삭제하자.
      localStorage.removeItem("heroNo")
      return
    }
    setHero(hero)
    setHeroNo(heroNo)
    const featuresResponse = await butterflyApi.getHeroFeatures(heroNo)
    setFeatures(featuresResponse.items)
  }


  const loadProcessing = async () => {
    const processing = await butterflyApi.getProcessing()
    setProcessing(processing)
  }

  const loadApps = async () => {
    const selectedHeroNo = isLogin() ? localStorage.getItem("heroNo") : ''
    const apps = await butterflyApi.getApps('', selectedHeroNo)
    setApps(apps || [])
  }

  const onBookClick = (scriptNo, isSampleStory) => {
    const code = Utils.makeCode(scriptNo, heroNo)
    const detailParams = new URLSearchParams()

    if (isSampleStory) {
      detailParams.set('sample', 'true')
    }

    navigate(`/fairytales/${code}${detailParams.toString() ? `?${detailParams.toString()}` : ''}`)
  }

  useEffect(() => {
    load();
  }, [])

  useEffect(() => {
    if (!location.hash) return

    const targetId = location.hash.replace('#', '')
    const scrollTimer = window.setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)

    return () => window.clearTimeout(scrollTimer)
  }, [location.hash])

  useEffect(() => {
    if (!activeMovie) return

    const originalOverflow = document.body.style.overflow
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setActiveMovie()
      }
    }

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.style.overflow = originalOverflow
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [activeMovie])

  const hotStories = scripts.filter(script => script.hot)
  const complatedStories = heroNo && hero && scripts.filter(script => script.verified && script.scriptImageCreated).sort((a, b) => {
    return new Date(b.verifiedDatetime) - new Date(a.verifiedDatetime)
  }) || []
  const hasComplatedStories = complatedStories.length > 0
  const featuredStories = hasComplatedStories ? complatedStories.slice(0, 5) : hotStories
  const featuredTitle = hasComplatedStories ? '새로운 이야기' : '인기 이야기'
  const featuredTitleIcon = hasComplatedStories ? './image/main/new.png' : './image/main/best.png'
  const makingStories = scripts.filter(script => !Utils.isSampleScript(script) && (!script.verified || !script.scriptImageCreated))
  const heroName = hero && callName(hero.firstName) || '우리 아이'
  const gameApps = apps.filter(app => app.category === 'game')
  const hasRegisteredHero = isLogin() && (JSON.parse(localStorage.getItem('heroes') || '[]')?.length > 0)



  return <MobilePage className='home-page'>
    <main className='home-content'>
      <section className='home-hero' aria-labelledby='home-title'>
        <div className='home-hero-copy'>
          <span className='home-eyebrow'><span aria-hidden='true'>✦</span> 우리 가족만의 특별한 동화</span>
          <h1 id='home-title'>오늘 이야기의 주인공은<br /><em>{hero ? heroName : '우리 아이'}예요.</em></h1>
          <p>아이의 모습과 이름, 사랑하는 가족까지.<br />함께라서 더 특별한 이야기를 만나보세요.</p>
        </div>
        <img
          className='home-hero-art'
          src='/image/main/home-storybook.webp'
          alt='숲속에서 아이와 부모가 함께 동화책을 읽는 모습'
          width='1536'
          height='1024'
          fetchpriority='high'
        />
        <div className='home-hero-actions'>
          <button className='home-primary-button' type='button' onClick={() => navigate(!isLogin() ? '/login' : hasRegisteredHero ? '/fairytales' : '/heroes')}>
            {isLogin() ? '우리 아이 이야기 만나기' : '우리 아이 이야기 시작하기'}<span aria-hidden='true'>→</span>
          </button>
          <Link to='/fairytales?sample=true' className='home-hero-preview'>샘플 동화 먼저 둘러보기 <span aria-hidden='true'>↗</span></Link>
        </div>
      </section>

      <nav className='home-shortcuts' aria-label='콘텐츠 바로가기'>
        <Link to='/fairytales'><img src='/image/main/books.png' alt='' width='32' height='32' /><span>동화</span><span aria-hidden='true'>›</span></Link>
        <a href='https://tellingpapa.com/apps/good-job-sticker-v3/index.html'><img src='/image/main/good-job-sticker.png' alt='' width='32' height='32' /><span>칭찬스티커</span><span aria-hidden='true'>›</span></a>
        <a href='#main-games'><img src='/image/main/games.png' alt='' width='32' height='32' /><span>게임</span><span aria-hidden='true'>›</span></a>
        <a href='#main-videos'><img src='/image/main/movies.png' alt='' width='32' height='32' /><span>영상</span><span aria-hidden='true'>›</span></a>
      </nav>

      {processing && processing.length > 0 && <ProcessingRolling items={processing} />}

      <section className='home-section home-featured' aria-labelledby='featured-heading'>
        <SectionHeading
          id='featured-heading'
          title={featuredTitle}
          description={hasComplatedStories ? `${heroName}의 새로운 모험이 기다려요.` : '어떤 모험부터 시작해 볼까요?'}
          icon={featuredTitleIcon}
        >
          {!hasComplatedStories && <Link className='home-text-link' to={isLogin() ? '/fairytales' : '/fairytales?sample=true'}>전체보기 <span aria-hidden='true'>›</span></Link>}
        </SectionHeading>
        <BookSlideList scripts={featuredStories} onBookClick={onBookClick} />
      </section>

      <section className='home-library' aria-labelledby='library-heading'>
          <div className='home-suggestion'>
            <Suggetion hero={hero} features={features} heroName={heroName} makingStories={makingStories} complatedStories={complatedStories} />
          </div>
          <SectionHeading id='library-heading' title='이야기 책장' description='한 편씩, 상상이 자라는 시간' icon='/image/main/books.png'>
            <Link className='home-text-link' to='/fairytales'>전체보기 <span aria-hidden='true'>›</span></Link>
          </SectionHeading>
          <BookRowList scripts={scripts} onBookClick={onBookClick} />
      </section>

      <section className='home-section home-sticker' aria-labelledby='sticker-heading'>
        <SectionHeading id='sticker-heading' title='칭찬 스티커' description='우리 아이의 멋진 순간을 스티커로 칭찬해 주세요.' icon='/image/main/good-job-sticker.png' />
        <iframe
          title='칭찬 스티커'
          src={`https://tellingpapa.com/apps/good-job-sticker-v3/embed.html${heroNo ? `?heroNo=${encodeURIComponent(heroNo)}` : ''}`}
          loading='lazy'
        />
      </section>

      <section id='main-games' className='home-section' aria-labelledby='games-heading'>
        <SectionHeading id='games-heading' title='놀면서 자라요' description='게임 속에서도 우리 아이가 주인공!' icon='/image/main/games.png' />
        <div className='home-game-list'>
          {
            gameApps.map(game => {
              const appName = getAppName(game, heroName)
              const productionStatusText = getAppProductionStatusText(game.productionStatus)
              const executionUrl = game.resultUrl || game.appUrl
              const paymentLocked = hasPaidAppProduction(game)

              return <article className='home-game-card' key={game.appNo}>
                <img className='home-game-image' src={game.imageUrl} alt='' loading='lazy' width='112' height='112' />
                <div className='home-game-copy'>
                  <h3>{appName}</h3>
                  <p>{game.description}</p>
                  {productionStatusText && <span className='home-status'>{productionStatusText}</span>}
                </div>
                <div className='home-game-actions'>
                  <button
                    type='button'
                    className='home-play-button'
                    disabled={!executionUrl}
                    onClick={() => {
                      if (executionUrl) {
                        window.location.href = executionUrl
                      }
                    }}
                    aria-label={`${appName} 실행하기`}
                  >
                    <span className='home-play-icon' aria-hidden='true' />{executionUrl ? '게임 하기' : '준비 중'}
                  </button>
                  {SHOW_GAME_CREATION && <button
                    type='button'
                    className='home-make-button'
                    aria-label={`${appName} ${paymentLocked ? '주문내역' : '제작하기'}`}
                    onClick={() => { navigate(paymentLocked ? '/orders' : `/apps/${game.appNo}/payment`) }}
                  >
                    {paymentLocked ? '주문내역' : '우리 아이로 제작'} <span aria-hidden='true'>›</span>
                  </button>}
                </div>
                {SHOW_GAME_CREATION && <div className='home-game-price'>
                  <span>맞춤 제작</span>
                  <div>
                    {game.discountPrice > 0 && <del>{formatPrice(game.salePrice)}</del>}
                    <strong>{formatPrice(getPurchasePrice(game))}</strong>
                  </div>
                </div>}
              </article>
            })
          }
        </div>
      </section>
      <section id='main-videos' className='home-section' aria-labelledby='videos-heading'>
        <SectionHeading id='videos-heading' title='동영상' description='짧은 영상으로 만나는 우리 아이의 모험' icon='/image/main/movies.png' />
        <div className='home-video-list'>
          {
            MOVIE_ITEMS.map(movie => <button
              type='button'
              key={movie.youtubeUrl}
              className='home-video-card group'
              onClick={() => setActiveMovie(movie)}
              aria-label={movie.title}
            >
              <div className='home-video-image'>
                <img
                  className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
                  src={movie.thumbnailUrl}
                  alt={movie.title}
                  loading='lazy'
                />
                <div className='absolute inset-0 bg-black/20' />
                <div className='absolute inset-0 flex items-center justify-center'>
                  <span className='flex h-12 w-12 items-center justify-center rounded-full bg-white/90 shadow-md'>
                    <span className='ml-1 block h-0 w-0 border-y-[10px] border-y-transparent border-l-[16px] border-l-new-green' />
                  </span>
                </div>
              </div>
              <span className='home-video-title'>{movie.title}<span aria-hidden='true'>↗</span></span>
            </button>)
          }
        </div>
      </section>

      {
        activeMovie && <div
          className='fixed inset-0 z-[100] flex items-center justify-center bg-black/80 px-4 py-6'
          onClick={() => setActiveMovie()}
        >
          <button
            type='button'
            className='absolute right-4 top-4 z-[101] flex h-11 w-11 items-center justify-center rounded-full bg-white/90 text-new-black shadow-lg'
            aria-label='영상 닫기'
            onClick={(event) => {
              event.stopPropagation()
              setActiveMovie()
            }}
          >
            <span className='text-3xl leading-none' aria-hidden='true'>&times;</span>
          </button>
          <div
            className='w-full'
            style={{ maxWidth: 'min(92vw, calc(88vh * 9 / 16))' }}
            onClick={(event) => event.stopPropagation()}
          >
            <div className='aspect-[9/16] overflow-hidden rounded-lg bg-black shadow-2xl'>
              <iframe
                className='h-full w-full'
                src={getMovieEmbedUrl(activeMovie)}
                title={activeMovie.title}
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                allowFullScreen
                referrerPolicy='strict-origin-when-cross-origin'
              />
            </div>
          </div>
        </div>
      }

      <footer className='home-footer'>
        <div className='home-footer-brand'>
          <img src='/image/tellingpapa_text.png' alt='Telling Papa' width='64' height='32' />
          <p>작은 이야기에서 시작되는, 커다란 상상.</p>
        </div>
        <nav aria-label='사이트 안내'>
          <Link to='/support/inquiries'>1:1 문의</Link>
          <Link to='/terms'>이용약관</Link>
          <Link to='/privacy-policy'>개인정보처리방침</Link>
        </nav>
        <small>&copy; {new Date().getFullYear()} TellingPapa. All rights reserved.</small>
      </footer>
    </main>
  </MobilePage>
}

export default Main
